import { inr } from "@/lib/format";

export default function PayrollSummary({ totals, testid = "payroll-summary" }) {
  const items = [
    ["employees", "Total Employees", totals.employees, "text-slate-900", false],
    ["salary", "Total Monthly Salary", totals.salary, "text-slate-900", true],
    ["earned", "Total Earned Salary", totals.earned, "text-slate-900", true],
    ["deduction", "Total Deductions", totals.deduction, "text-red-700", true],
    ["final", "Total Final Payable", totals.final, "text-blue-800", true],
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid={testid}>
      {items.map(([k, l, v, c, money]) => (
        <div key={k} className={`bg-white rounded-xl border p-4 ${k === "final" ? "border-blue-300 col-span-2 lg:col-span-1" : "border-slate-200"}`}>
          <div className="text-[11px] uppercase tracking-wider font-semibold text-slate-500">{l}</div>
          <div className={`money text-xl font-bold mt-1 ${c}`} data-testid={`${testid}-${k}`}>{money ? inr(v) : v}</div>
        </div>
      ))}
    </div>
  );
}
